<template>
  <div
    class="blog-item cursor-pointer with-hover"
    @click="redirectToCurrentBlog"
  >
    <div
      class="post-img"
    >
      <img
        :src="blog.image_url"
        alt="Fluid image"
      >
    </div>
    <div
      class="text-primary font-weight-bold l-h-20 grey-dark post-title text-center"
    >
      {{ blog.title }}
    </div>
  </div>
</template>

<script>
import { R_BLOG_DETAILS } from '@/router/routes';
import { scrollToTop } from '@/helpers/helpers';

export default {
  name: 'RelatedPostItem',
  props: {
    blog: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    async redirectToCurrentBlog() {
      this.loading = true;
      await this.$router.push({
        name: R_BLOG_DETAILS,
        query: {
          id: this.blog.id,
        },
      });
      scrollToTop();
      this.$emit('get-data');
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.post-img {
  padding: 50px;
  background-color: #BCC0D2;
}
.post-title {
  padding: 50px;
}
</style>
